import React, { useEffect, useContext, useState } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import Layout from "../../../components/common/Layout";
import axios from "axios";
import AlertContext from "../../../context/alert/alertContext";
import Alerts from "../../layout/Alerts";
import checkTime from "../../../components/constants/CheckTime"

const InvoiceEdit = props => {
  
  const alertContext = useContext(AlertContext);
  const { setAlert } = alertContext;
  const userId =
    JSON.parse(localStorage.getItem("user")) === null
      ? null
      : JSON.parse(localStorage.getItem("user"))[0].Id;
  const [showConfirm, setShowConfirm] = useState(false);
  const [showDuplicate, setShowDuplicate] = useState(false);

  const [dataShow, setDataShow] = useState({
    applicationNo: '',
    registrationNo: '',
    fileReference: ''
  });
  
  const nameData = [
    {
      col1:"item1"
      ,col2:"1"
      ,col3:"100,000"
    },
    {
      col1:"item2"
      ,col2:"1"
      ,col3:"100,000"
    },
    {
      col1:"item3"
      ,col2:"1"
      ,col3:"100,000"
    }
  ]

  const nameColumns = [
    {
      name: "Item",
      selector: "col1",
      sortable: true,
      wrap: true
    },
    {
      name: "Quantity",
      selector: "col2",
      sortable: true,
      wrap: true
    },
    {
      name: "Price",
      selector: "col3",
      width: "100px",
      sortable: true,
      wrap: true
    },
    {
      cell: (row) => (
        <div>
          <input 
          type="checkbox" 
          className="checkboxCustom1"
          /> 
        </div>
      ),
      name: "VAT",
      ignoreRowClick: false,
      allowOverflow: true,
      show: 1
    }
  ];

  const button = () => {
    return (
      <div className="text-right mb-2 mt-2">
        <div>
          <button
            className="btn btn-success ml-2"
            type="button"
          >
            <i className="fa fa-save"></i> Save
          </button>
          {props.match.path.indexOf("edit") > 0 && (
            <button
              className="btn btn-secondary ml-2"
              type="button"
            >
              <i className="fa fa-refresh"></i> Reset
            </button>
          )}
          <Link to="/cases">
            <button className="btn btn-danger ml-2" type="button">
              <i className="fa fa-reply"></i> Cancel
            </button>
          </Link>
        </div>
      </div>
    );
  };
 
  return (
    <Layout activeLinkTo="/invoices" menuId="21">
      <div className="container-fluid" style={{ minHeight: 500 }}>
        <Alerts />
        {button()}
        <div className="card border-secondary">
          {props.match.path.indexOf("add") > 0 && (
            <h5 className="card-header text-white bg-primary">Add Invoice</h5>
          )}
          {props.match.path.indexOf("edit") > 0 && (
            <h5 className="card-header text-white bg-primary">Edit Invoice</h5>
          )}

          <div className="card-body">
            <div className="card mt-2">
              <div className="card-body row">
                <div className="form-group col-lg-6 labelPadRight">
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Ref. quatation<span style={{ color: "red" }}> * </span>:
                    </label>
                    <div className="input-group col-md-9">
                      <input
                        readOnly
                        type="text"
                        name="family"
                        className="form-control  form-control-sm"
                      />

                      <div className="input-group-append">
                        <button disabled={props.match.path.indexOf("edit") > 0}
                          className="btn btn-sm btn-outline-primary form-control-sm"
                          type="button"
                          onClick={() => {
                          }}
                        >
                          <i className="fa fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Customer Name<span style={{ color: "red" }}> * </span>:
                    </label>
                    <div className="input-group col-md-9">
                      <input
                        readOnly
                        type="text"
                        name="family"
                        className="form-control  form-control-sm"
                      />

                      <div className="input-group-append">
                        <button disabled={props.match.path.indexOf("edit") > 0}
                          className="btn btn-sm btn-outline-primary form-control-sm"
                          type="button"
                          onClick={() => {
                          }}
                        >
                          <i className="fa fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Price :
                    </label>
                    <div className="col-md-9">
                    <input
                        type="text"
                        name="family"
                        className="form-control  form-control-sm"
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group col-lg-6">
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      Status<span style={{ color: "red" }}> * </span>:
                    </label>
                    <div className="col-md-9">
                      <Select isDisabled={props.match.path.indexOf("edit") > 0}
                        name="caseOffice"
                        value={{
                          value: 0,
                          label: "Please Select"
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-group row col">
                    <label className="col-md-3 col-form-label form-control-sm sbold">
                      VAT:
                    </label>
                    <div className="col-md-9">
                      <input 
                        type="checkbox" 
                        className="checkboxCustom1"
                        /> 
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-2">
              <div className="form-group col">
                <div className="card mb-3">
                  <div className="card-header text-white bg-primary">
                    Other Details
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group row col">
                        <DataTable
                          noHeader={true}
                          pagination={true}
                          paginationPerPage={50}
                          paginationRowsPerPageOptions={[10, 20, 50, 100]}
                          columns={nameColumns}
                          data={nameData}
                        />
                          <div className="form-group row col">
                            <lable className="col-md-12" style={{textAlign: "right"}}>Total : 300,000</lable>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {button()}
      </div>

      {/* Modal Save */}
      <Modal
        show={showConfirm}
        onHide={() => {
          setShowConfirm(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              setShowConfirm(false);
            }}
          >
            <i className="fa fa-reply"></i> Cancel
          </button>
          <button
            className="btn btn-success ml-2"
            type="button"
          >
            <i className="fa fa-floppy-o"></i> Save
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Save */}

      {/* Modal Case Duplicate */}
      <Modal
        show={showDuplicate}
        onHide={() => {
          setShowDuplicate(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alerts />
          <p>Case already exist in the system, create new one?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              setShowDuplicate(false);
            }}
          >
            <i className="fa fa-reply"></i> Cancel
          </button>
          <button
            className="btn btn-success ml-2"
            type="button"
          >
            <i className="fa fa-floppy-o"></i> Save
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Case Duplicate */}
    </Layout>
  );
};

export default InvoiceEdit;
